require('./contractLoanTooltip.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@utilities
const { formatPercentage, getFormattedString } = require('utilities/currencyHelper');

class ContractLoanTooltip extends React.Component {
    buildClarifyingText(clarifyingText) {
        return (
            <div className="contract-loan-tooltip__clarifying-text">
                <FormattedText value={'contractLoanTooltip-' + clarifyingText} />
            </div>
        );
    }

    buildInstallment() {
        const { immContractLoan } = this.props;
        const immCollective = immContractLoan.getIn(['collectiveInformation', '0']);
        const isCollective = immContractLoan.get('isCollective');
        return (isCollective && immCollective) ? {
            amount: immCollective.get('installment'),
            currency: immContractLoan.get('currency')
        } : immContractLoan.get('installment');
    }

    buildImport() {
        const { immContractLoan, customAmount, decimalsLength } = this.props;
        const currency = immContractLoan.get('currency');
        const amount = customAmount ? customAmount : immContractLoan.get('selectedAmount');

        return {
            amount,
            currency,
            decimalsLength
        };
    }

    buildList(totalRaw) {
        const { immContractLoan, customAmount, isRetailLoan } = this.props;

        const currency = immContractLoan.get('currency');
        const commissionAmount = { amount: immContractLoan.get('arrangementFee'), currency };
        const arrangementPercentage = immContractLoan.get('arrangementPercentage');
        const monthlyPay = customAmount ? formatText('retailLoanSidebar-payment') : formatText('contractLoanTooltip-monthlyInstallment');

        const immCollective = immContractLoan.getIn(['collectiveInformation', '0']);
        const isCollective = immContractLoan.get('isCollective');
        const tin = isCollective ? immCollective.get('tin') : immContractLoan.get('tin');
        const installment = this.buildInstallment();
        const loanImport = this.buildImport();
        const commissionPlusInterest = {
            amount: isRetailLoan ? 0 : totalRaw.amount - loanImport.amount,
            currency
        };

        const listElements = [
            {
                label: formatText('contractLoanTooltip-loanImport'),
                text: getFormattedString(loanImport, !isRetailLoan)
            },
            {
                label: formatText('contractLoanTooltip-term'),
                text: formatText('contractEasyLoan-termMonths', [immContractLoan.get('selectedTerm')])
            },
            {
                label: formatText('contractLoanTooltip-TIN'),
                text: formatPercentage(tin)
            },
            {
                label: (
                    <React.Fragment>
                        {formatText('contractLoanTooltip-openingCommission')}
                        {!isRetailLoan ? <sup>1</sup> : null}
                    </React.Fragment>
                ),
                text: getFormattedString(commissionAmount)
            },
            {
                label: formatText('contractEasyLoanTooltip-requestedAmount', [arrangementPercentage]),
            },
            {
                label: monthlyPay,
                text: getFormattedString(installment)
            }
        ];

        const labelList = [];
        const textsList = [];

        listElements.forEach((item, index) => {

            if (item.hidden) {
                return;
            }

            labelList.push(
                <div key={'list-label' + index} className="contract-loan-tooltip__list-label">
                    {item.label}
                </div>
            );

            const textElementStyle = classnames(
                'contract-loan-tooltip__list-value',
                {
                    'contract-loan-tooltip__list-value--empty': !item.text
                }
            );

            textsList.push(
                <div key={'list-value' + index} className={textElementStyle}>
                    {item.text}
                </div>
            );
        });

        return (
            <div>
                <div className="contract-loan-tooltip__values-container">
                    {textsList}
                </div>
                <div className="contract-loan-tooltip__list-separator" />
                <div className="contract-loan-tooltip__labels-container">
                    {labelList}
                </div>
                <div className="contract-loan-tooltip__list-note">
                    {formatText('contractEasyLoanTooltip-contractEasyLoanTooltip_noteList', [getFormattedString(commissionPlusInterest)])}
                </div>
            </div>
        );
    }

    buildTotalAmount() {
        const { immContractLoan, customAmount } = this.props;
        const currency = immContractLoan.get('currency');
        const immCollective = immContractLoan.getIn(['collectiveInformation', '0']);
        const isCollective = immContractLoan.get('isCollective');
        const amount = isCollective ? immCollective.get('totalAmount') : immContractLoan.get('totalAmount');

        return {
            amount,
            currency,
            decimalsLength: customAmount && 2
        };
    }

    render() {
        const { immContractLoan, clarifyingText } = this.props;

        const totalRaw = this.buildTotalAmount();
        const totalAmount = getFormattedString(totalRaw);
        const listElements = this.buildList(totalRaw);

        const immCollective = immContractLoan.getIn(['collectiveInformation', '0']);
        const isCollective = immCollective && immContractLoan.get('isCollective');

        const taeRaw = isCollective ? immCollective.get('tae') : immContractLoan.get('tae');
        let tae = formatPercentage(taeRaw);
        let formattedTotalImport = formatText('contractLoanTooltip-totalImport');
        let clarifyingTextContainer;

        const footerClasses = classnames(
            'contract-loan-tooltip__footer',
            {
                'contract-loan-tooltip__footer--has-clarifying-text': !!clarifyingText
            }
        );

        if (clarifyingText) {
            clarifyingTextContainer = this.buildClarifyingText(clarifyingText);
            tae = tae.concat(' ', '*');
            formattedTotalImport = formattedTotalImport.concat(' ', '*');
        }

        return (
            <div className="contract-loan-tooltip">
                <div className="contract-loan-tooltip__header">
                    <FormattedText value="contractLoanTooltip-title" injectedStrings={[tae]} />
                </div>
                <div className="contract-loan-tooltip__body">
                    {listElements}
                </div>
                <div className={footerClasses}>
                    <div className="contract-loan-tooltip__footer-import">
                        {totalAmount}
                    </div>
                    <div className="contract-loan-tooltip__list-separator" />
                    <div className="contract-loan-tooltip__footer-label">
                        <div>
                            {formattedTotalImport}
                        </div>
                        <div className="contract-loan-tooltip__footer-submessage">
                            <FormattedText value="contractLoanTooltip-summatory" />
                        </div>
                    </div>
                </div>
                {clarifyingTextContainer}
            </div>
        );
    }
}

ContractLoanTooltip.propTypes = {
    immContractLoan: PropTypes.object.isRequired,
    clarifyingText: PropTypes.string,
    decimalsLength: PropTypes.number,
    isRetailLoan: PropTypes.bool,
    customAmount: PropTypes.number
};

ContractLoanTooltip.defaultProps = {
    decimalsLength: 0,
    isRetailLoan: false,
}

module.exports = ContractLoanTooltip;
